import { Fragment } from 'react';

/**
 * Names joined by slashes (Triamterene/Hydrochlorothiazide) have no line-break
 * point, so in a heading or a button on a 360 px phone they ran past the
 * screen and the page scrolled sideways (2026-10-16). <wbr> adds a break point
 * after each slash without adding a character to the text.
 */
export function SlashBreaks({ text }: { text: string }) {
  const parts = text.split('/');
  return (
    <>
      {parts.map((part, i) => (
        <Fragment key={i}>
          {part}
          {i < parts.length - 1 && (
            <>
              /<wbr />
            </>
          )}
        </Fragment>
      ))}
    </>
  );
}
